module.exports = __webpack_public_path__ + "static/media/elo_promoters_logos_mobile.48d97c4e.webp";